module.exports = __webpack_public_path__ + "img/planetary-rev06.683945ad.jpg";